import React from 'react';

import testIds from '@smart-tv/e2e/shared/variables';

import Typography from '@smart-tv/components/typography';

import useGDPR from '@smart-tv/hooks/use-gdpr';

import { IS_BROWSER } from '@smart-tv/utils/is-browser';

import styles from './gdpr-dialog.module.scss';

export const GDPRDescription: React.FC<{ openedFromSettings: boolean }> = ({
  openedFromSettings
}) => {
  const { gdprText } = useGDPR();

  const linkHref = gdprText?.link
    ? gdprText.link.startsWith('http')
      ? gdprText.link
      : `https://${gdprText.link}`
    : undefined;

  return (
    <React.Fragment>
      <Typography variant="h3" data-testid={testIds.gdpr.header}>
        {gdprText?.title}
      </Typography>
      <Typography
        variant="bodySmall"
        data-testid={testIds.gdpr.textMain}
        className={styles['gdpr-text']}
      >
        {gdprText?.main}
      </Typography>
      <Typography
        variant="bodySmall"
        data-testid={testIds.gdpr.textLast}
        className={styles['gdpr-text']}
      >
        {gdprText?.last}
      </Typography>
      {gdprText?.link && (
        <Typography
          variant="caption"
          data-testid={testIds.gdpr.link}
          className={styles['gdpr-link-text']}
        >
          {openedFromSettings && <br />}
          Læs mere på:{' '}
          {IS_BROWSER ? (
            <a href={linkHref} target="_blank" rel="noopener noreferrer">
              {gdprText.link}
            </a>
          ) : (
            gdprText.link
          )}
        </Typography>
      )}
      {gdprText?.link && !IS_BROWSER && (
        <Typography variant="caption" fontWeight="light">
          {openedFromSettings && <br />}
          Brug en mobiltelefon eller computer for at gå til siden.
        </Typography>
      )}
    </React.Fragment>
  );
};

export default React.memo(GDPRDescription);
